export const datePickerAsNumberStyles = {
  datePickerStyle: {
    paddingLeft: 10,
    paddingRight: 20,
    paddingTop: 15
  }
}
